module.exports = __webpack_public_path__ + "img/google-btn.01e29759.jpg";